import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { StepStatus } from '~/enums';
import { trackCardOfferActions } from '~/store/actions/analyticsActions';
import { goToNextStep } from '~/store/slices/cardOffer.slice';
import { RootState } from '~/store';

export const useGoToNextStepCardOffer = () => {
  const dispatch = useAppDispatch();
  const { currentStep } = useSelector((state: RootState) => state.cardOffer);
  const onNextStepClick = useCallback(() => {
    dispatch(trackCardOfferActions({ actionName: 'next_button_pressed' }));
    dispatch(trackCardOfferActions({ stepStatus: StepStatus.Finished }));
    dispatch(goToNextStep());
  }, [dispatch, currentStep]);

  return onNextStepClick;
};
